(() => {
  if (window.__dfScrollingContentDragV2) return;
  window.__dfScrollingContentDragV2 = true;

  let drag = null;
  let suppressClick = false;
  let momentum = null;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const momentumFriction = 0.955;
  const momentumBoost = 1.35;
  const maximumVelocity = 4;

  const wrapTime = (time, duration) => ((time % duration) + duration) % duration;

  function stopMomentum() {
    if (!momentum) return;
    cancelAnimationFrame(momentum.frame);
    momentum.animation.play();
    momentum = null;
  }

  function startMomentum(animation, duration, distance, velocity) {
    if (reduceMotion.matches || Math.abs(velocity) < 0.08) {
      animation.play();
      return;
    }

    let previousTime = performance.now();
    momentum = { animation, frame: 0 };

    const tick = (time) => {
      if (!momentum || momentum.animation !== animation) return;

      const elapsed = Math.min(time - previousTime, 32);
      previousTime = time;
      animation.currentTime = wrapTime(
        (Number(animation.currentTime) || 0) + velocity * elapsed / distance * duration,
        duration
      );
      velocity *= Math.pow(momentumFriction, elapsed / 16.667);

      if (Math.abs(velocity) < 0.025) {
        momentum = null;
        animation.play();
      } else {
        momentum.frame = requestAnimationFrame(tick);
      }
    };

    momentum.frame = requestAnimationFrame(tick);
  }

  function findAnimation(marquee) {
    const scroller = marquee.shadowRoot?.querySelector('[part="scroller"]');
    return scroller?.getAnimations().find((animation) => {
      return animation.effect?.getTiming?.().iterations === Infinity;
    });
  }

  function finish(event) {
    if (!drag || event.pointerId !== drag.pointerId) return;

    const state = drag;
    drag = null;
    state.marquee.classList.remove('is-df-dragging');

    if (state.marquee.hasPointerCapture?.(event.pointerId)) {
      state.marquee.releasePointerCapture(event.pointerId);
    }

    const now = performance.now();
    const samples = state.samples.filter((sample) => now - sample.time <= 180);
    const first = samples[0];
    const sampleDuration = first ? now - first.time : 0;
    const measuredVelocity = first && sampleDuration > 8
      ? (event.clientX - first.x) / sampleDuration
      : state.velocity;
    const velocity = now - state.lastMoveAt > 180
      ? 0
      : Math.max(-maximumVelocity, Math.min(maximumVelocity, measuredVelocity * momentumBoost));

    if (state.moved) {
      startMomentum(state.animation, state.duration, state.distance, velocity);
      suppressClick = true;
      setTimeout(() => { suppressClick = false; }, 0);
    } else {
      state.animation.play();
    }
  }

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    const marquee = event.target.closest?.('marquee-text.scrolling-content');
    if (!marquee || marquee.hasAttribute('vertical')) return;

    const animation = findAnimation(marquee);
    const item = marquee.querySelector('.scrolling-content__item');
    const duration = Number(animation?.effect?.getTiming?.().duration);
    const itemWidth = item?.getBoundingClientRect().width || 0;
    const currentTime = Number(animation?.currentTime);

    if (!animation || !Number.isFinite(duration) || duration <= 0 || !itemWidth || !Number.isFinite(currentTime)) return;

    stopMomentum();

    const direction = marquee.getAttribute('direction') === 'end-to-start' ? -1 : 1;
    const logicalFlip = Number.parseFloat(
      getComputedStyle(marquee).getPropertyValue('--transform-logical-flip')
    ) || 1;
    const now = performance.now();

    drag = {
      marquee,
      animation,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startTime: currentTime,
      duration,
      distance: direction * logicalFlip * itemWidth,
      moved: false,
      velocity: 0,
      lastX: event.clientX,
      lastMoveAt: now,
      samples: [{ x: event.clientX, time: now }],
    };

    animation.pause();
    marquee.setPointerCapture?.(event.pointerId);
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.pointerId) return;

    const deltaX = event.clientX - drag.startX;
    const deltaY = event.clientY - drag.startY;
    const now = performance.now();
    const elapsed = now - drag.lastMoveAt;

    if (elapsed > 0) {
      const instantVelocity = (event.clientX - drag.lastX) / elapsed;
      drag.velocity = drag.velocity * 0.65 + instantVelocity * 0.35;
      drag.lastX = event.clientX;
      drag.lastMoveAt = now;
      drag.samples.push({ x: event.clientX, time: now });
      drag.samples = drag.samples.filter((sample) => now - sample.time <= 180);
    }

    if (!drag.moved) {
      if (Math.abs(deltaX) < 6) return;
      if (Math.abs(deltaY) > Math.abs(deltaX)) return;
      drag.moved = true;
      drag.marquee.classList.add('is-df-dragging');
    }

    event.preventDefault();
    drag.animation.currentTime = wrapTime(
      drag.startTime + deltaX / drag.distance * drag.duration,
      drag.duration
    );
  });

  document.addEventListener('pointerup', finish);
  document.addEventListener('pointercancel', finish);

  document.addEventListener('click', (event) => {
    if (!suppressClick || !event.target.closest?.('marquee-text.scrolling-content')) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);
})();
